import React, { useEffect, useMemo, useState } from "react";
import { getCurrentUser } from "../../auth";
import { loadTeacherWorkload } from "../../services/teacherWorkloadService";

export default function Gradebooks() {
  const user = getCurrentUser();
  const campus = String(user?.campus || "gapan").toLowerCase();
  const [schoolYear, setSchoolYear] = useState("");
  const [classes, setClasses] = useState([]);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    (async () => {
      const res = await loadTeacherWorkload({ user, campus });
      const wl = res.data || {};
      setSchoolYear(res.schoolYear || "");
      setMeta(wl._meta || null);
      const cls = Array.isArray(wl.classes) ? wl.classes.filter(c =>
        String(c.grade || "").trim() || String(c.section || "").trim() || String(c.subject || "").trim() || String(c.gradebookUrl || "").trim()
      ) : [];
      setClasses(cls);
    })();
  }, [user?.uid, user?.email, campus]);

  const links = useMemo(() => {
    return classes
      .map((c, idx) => ({
        idx,
        label: `${c.grade || ""} ${c.section || ""} — ${c.subject || "Gradebook"}`.trim(),
        url: String(c.gradebookUrl || c.gradebookLink || c.link || "")
      }))
      .filter(x => x.url);
  }, [classes]);

  return (
    <div className="container mt-4">
      <h3 className="mb-1">Gradebooks</h3>
      <div className="text-muted mb-3">{schoolYear ? `School Year: ${schoolYear}` : ""}</div>
      {meta?.source && <div className="text-muted small mb-2">Workload source: {meta.source}</div>}
      {meta?.source === "fallbackAdviserMap" && (
        <div className="text-muted small mb-2">
          UID: {meta?.uid || "—"} | Email: {meta?.email || "—"} | Campus: {meta?.campus || "—"}
        </div>
      )}
      {meta?.source === "fallbackAdviserMap" && meta?.attempted?.currentIds && (
        <div className="text-muted small mb-2">
          Tried current IDs: {Array.isArray(meta.attempted.currentIds) ? meta.attempted.currentIds.join(", ") : String(meta.attempted.currentIds)}
        </div>
      )}
      {meta?.source === "fallbackAdviserMap" && Array.isArray(meta?.errors) && meta.errors.length > 0 && (
        <div className="text-danger small mb-2">
          Load error: {meta.errors[0].code || ""} {meta.errors[0].message || ""}
        </div>
      )}
      <div className="card p-3">
        {links.length === 0 ? (
          <div className="text-muted">No gradebook links assigned yet</div>
        ) : (
          <div className="list-group">
            {links.map(l => (
              <button
                key={l.idx}
                type="button"
                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                onClick={() => window.open(l.url, "_blank", "noopener,noreferrer")}
              >
                <span style={{ fontWeight: 700 }}>{l.label}</span>
                <span className="text-muted">Open</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
